import ArtworkPreview from "./ArtworkPreview"

export default ArtworkPreview